import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SupabaseStatus from '@/components/ui/SupabaseStatus';
import ContactFormDialog from '@/components/home/ContactFormDialog';
import { useContactForm } from '@/contexts/ContactFormContext';

/**
 * Root layout that wraps all routes to provide GlobalContactForm
 * This ensures the contact form has access to router context
 */
const RootLayout = () => {
  const isReviewStore = useLocation().pathname === '/review-stands';
  return (
    <>
      <Outlet />
      <GlobalContactForm />
      {!isReviewStore && <SupabaseStatus />}
    </>
  );
};

// Component to handle the global contact form dialog
const GlobalContactForm = React.memo(() => {
  const { isOpen, closeContactForm } = useContactForm();

  const handleOpenChange = React.useCallback(
    (open: boolean) => {
      if (!open) {
        closeContactForm();
      }
    },
    [closeContactForm]
  );

  return (
    <ContactFormDialog open={isOpen} onOpenChange={handleOpenChange}>
      <span></span>
    </ContactFormDialog>
  );
});

export default RootLayout;
